import axios from 'axios';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/auth/';
const API_URL = 'https://www.edibleherbsstores.com/api/auth/';

class AuthService {
  /*login(user) {
    return axios
      .post(API_URL + 'signin', {
        username: user.username,
        password: user.password,
        withCredentials: false
      },
      {
        headers: { 
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "OPTIONS",
          "Access-Control-Allow-Headers": "Content-Type, Authorization",
          "Access-Control-Allow-Credentials": "false" 
        }
      }
      )
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }*/
  login(user) {
    return axios
      .post(API_URL + 'signin', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      staffNo: user.staffNo,
      firstName: user.firstName,
      lastName: user.lastName,
      username: user.username,
      email: user.email,
      password: user.password,
      userType: user.userType
    });
  }
}

export default new AuthService();